module.exports = __webpack_public_path__ + "static/media/lg.blue-longcat-spinner.dbcca15c.gif";